<div class="small text-muted" *ngIf="contract?.observations">
  <b>{{ 'GLOBAL.OBSERVATIONS'|translate }}:</b>
  {{ contract.observations }}
</div>
<p *ngIf="contract">
  <span class="material-symbols-rounded text-warning">local_shipping</span>&nbsp;<span [innerHtml]="'SLOTS.PENDING_VOLUME'|translate: {
    pending: (pendingVolume || 0) | number:'1.0-2':currentLang,
    unit: contract.quantity.unit.abbrev
  }"></span>&nbsp;<span *ngIf="pendingVolumeFixed != undefined"
    [class.text-warning]="pendingVolumeFixed > 0"
    [class.text-danger]="pendingVolumeFixed <= 0"
    [innerHtml]="pendingVolumeLabel|translate: {
      pending: myMath.abs(pendingVolumeFixed) | number:'1.0-2':currentLang,
      unit: contract.quantity.unit.abbrev
    }"></span>
</p>